import React from 'react';
import { FormattedMessage } from 'react-intl';

import { purchaseOrderGridProperties } from '../../data/purchase-order-properties';
import { messages } from '../messages';

const name = <FormattedMessage {...messages.warehouseColumnHeader} />;

/**
 * Warehouse column configuration
 * Displays the name of the warehouse for the purchase order
 * @type {import('./types').GridColumn} Column configuration object
 */
export const warehouseColumn = {
  name,
  render: (data) => data.warehouseName,
  id: purchaseOrderGridProperties.warehouseName,
};
